export default "__VITE_ASSET__Cv_1YQCc__"